import attributesData from './attributes.json';

/** Tipos del esquema de configuración data-driven (attributes.json). */
export type AttrType = 'single-select' | 'multi-select' | 'decimal';

export interface AttrOption {
  value: string;
  label: string;
  // Campos extra según el atributo (dimensiones, altura, postes, color…).
  ancho_mm?: number;
  largo_mm?: number;
  altura_mm?: number;
  count?: number;
  reinforced?: boolean;
  ral?: string;
  hex?: string;
  tier?: 'estandar' | 'premium';
  icon?: string;
}

export interface Attribute {
  label: string;
  type: AttrType;
  affectsGeometry: boolean;
  affectsPrice: boolean;
  default: string | number | string[];
  options?: AttrOption[];
  visibleWhen?: Record<string, string>;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  ui?: string;
}

export interface Step {
  id: string;
  label: string;
  attributes: string[];
}

export interface AttributesSchema {
  steps: Step[];
  attributes: Record<string, Attribute>;
}

export const SCHEMA = attributesData as unknown as AttributesSchema;

/** Estado del wizard: valor actual por id de atributo. */
export type WizardState = Record<string, string | number | string[]>;

/** Devuelve el estado inicial con los `default` de cada atributo. */
export function defaultState(): WizardState {
  const state: WizardState = {};
  for (const [id, attr] of Object.entries(SCHEMA.attributes)) {
    state[id] = Array.isArray(attr.default) ? [...attr.default] : attr.default;
  }
  return state;
}

/** ¿Es visible el atributo según `visibleWhen` y el estado actual? */
export function isAttributeVisible(id: string, state: WizardState): boolean {
  const attr = SCHEMA.attributes[id];
  if (!attr?.visibleWhen) return true;
  return Object.entries(attr.visibleWhen).every(([depId, depVal]) => {
    const cur = state[depId];
    return Array.isArray(cur) ? cur.includes(depVal) : cur === depVal;
  });
}

/** Busca una opción por valor dentro de un atributo. */
export function findOption(attrId: string, value: string): AttrOption | undefined {
  return SCHEMA.attributes[attrId]?.options?.find((o) => o.value === value);
}
